<template>

  <a-card :borded="false" class="m-b-20">
    <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="">
        <a-button size='small' @click="()=>{$router.go(-1)}">
          <LeftOutlined />返回
        </a-button>
      </a-form-item>
      <a-form-item label="请选择">
        <a-select v-model:value="search.search_date_type" style="width: 120px" @focus="focus" ref="select" @change="handleChange">
          <a-select-option value="1">日</a-select-option>
          <a-select-option value="2">自然周</a-select-option>
          <a-select-option value="3">自然月</a-select-option>
          <a-select-option value="7">近7天</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="">
        <a-date-picker v-model:value="search.search_time" v-if="search.search_date_type=='1'" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' />
        <a-week-picker v-model:value="weekTime" v-else-if="search.search_date_type=='2'" @change="changeWeek" />
        <a-month-picker v-model:value="search.search_time" v-else-if="search.search_date_type=='3'" valueFormat='YYYY-MM' format='YYYY-MM' />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
  </a-card>
  <a-card :bordered="false">
    <div class="m-t-10 m-b-10">经销商订货商品</div>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='list'>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
</template>
<script>
import { useTime } from "@/hooks/utils/useTime";
import { reactive, ref, toRefs } from "@vue/reactivity";
import { inject, onMounted } from "@vue/runtime-core";
import useTableSearch from "@/hooks/useTableSearch";
import { LeftOutlined } from "@ant-design/icons-vue";
import {statisticsGoodsLog} from '@/api/online'
const def = {
  search_date_type: "1",
  search_time: "",
  limit: 10,
  page: 1,
};
export default {
  components: { LeftOutlined },
  setup() {
    const {
      pageCurrentChange,
      pageSizeChange,
      search,
      list,
      initData,
      total,
      pageSearchChange,
      listLoading,
    } = useTableSearch({ data: def });
    const tableHoosks = {
      pageCurrentChange,
      pageSizeChange,
      search,
      initData,
      list,
      total,
      pageSearchChange,
      listLoading,
    };
    let columns = [
      {
        title: "商品名称",
        dataIndex: "goods_name",
        key: "goods_name",
      },
      {
        title: "规格",
        dataIndex: "goods_sku_name",
        key: "goods_sku_name",
      },
      {
        title: "单价（积分）",
        dataIndex: "point_price",
        key: "point_price",
        sorter: (a, b) => a.point_price - b.point_price,
      },
      {
        title: "数量",
        dataIndex: "goods_num",
        key: "goods_num",
        sorter: (a, b) => a.goods_num - b.goods_num,
      },
      {
        title: "总支付积",
        dataIndex: "total_point_price",
        key: "total_point_price",
      },
    ];
    const state = reactive({
      active: "1",
    });
    const dateTime = reactive({
      dayTime: "",
      weekTime: "",
      monthTime: "",
      quarterTime: "",
      time: [],
    });
    const { typeToStartEnd,dateTargets } = useTime();
    // 切换时间
         // 切换时间
    const handleChange = (e) => {
      search.value.search_time = "";
      switch (e) {
        case "1":
          search.value.search_time = dateTargets();
          break;
        case "2":
          search.value.search_time =
            typeToStartEnd("7").start_time + "," + typeToStartEnd("7").end_time;
            dateTime.weekTime=typeToStartEnd("week").end_time
          break;
        case "3":
          search.value.search_time = dateTargets("month");
          break;
      }
    };
    // 切换周
    const momentTime = inject("momentTime");
    const changeWeek = (weekData) => {
      if (!weekData) {
        search.value.search_time = "";
        return;
      }
      const startDate = momentTime(weekData).day(1).format("YYYY-MM-DD"); // 周一日期
      const endDate = momentTime(weekData).day(7).format("YYYY-MM-DD"); // 周日日期
      search.value.search_time = startDate + "," + endDate;
    };
    const $route=inject('$route')
    onMounted(() => {
      search.value.search_date_type=$route.query.search_date_type
      search.value.search_time=$route.query.search_time
      dateTime.weekTime=$route.query.weekTime
    
      tableHoosks.initData(statisticsGoodsLog,{...search.value,buyer_id:$route.query.buyer_id})
    });
    return {
      ...toRefs(dateTime),
      ...toRefs(state),
      search,
      handleChange,
      ...tableHoosks,
      columns,
      changeWeek
    };
  },
};
</script>
<style lang="less" scoped>
.data-content-nav {
  background: #eee;
  border-radius: 10px;

  .data-content-nav-item {
    color: #8e8e8e;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
    text-align: center;
    .title {
      font-size: 16px;
      color: #000000;
    }

    .num {
      font-size: 34px;
      color: #000;
    }
    &.active {
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(27, 66, 108, 0.28);
      border-radius: 10px;
    }
  }
}
</style>